import React, { useEffect, useState } from 'react';
import { listMcpServers, runMcpTest } from '../utils/api';

function AiMcpTestPanel({ setMessage }) {
  const [servers, setServers] = useState([]);
  const [serverId, setServerId] = useState('');
  const [query, setQuery] = useState('latest AI news');
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
  listMcpServers()
      .then((data) => {
        const all = [...(data.owned || []), ...(data.public || [])];
        setServers(all);
        if (all.length) setServerId(all[0].id);
      })
      .catch((err) => setMessage?.({ type: 'error', text: err.message || 'Failed to load MCP servers' }));
  }, [setMessage]);

  const handleRun = async () => {
    if (!serverId) {
      setMessage?.({ type: 'error', text: 'Select an MCP server' });
      return;
    }
    try {
      setRunning(true);
      setResult(null);
      const payload = await runMcpTest({ serverId, query: query.trim() || undefined });
      setResult(payload);
      setMessage?.({
        type: payload.success ? 'success' : 'error',
        text: payload.success
          ? `MCP test OK — ${payload.toolCount ?? 0} tool(s)`
          : payload.error || 'MCP test failed'
      });
    } catch (err) {
      setMessage?.({ type: 'error', text: err.message || 'MCP test failed' });
      setResult(null);
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="mcp-test-panel web-search-test-panel">
      <p className="panel-intro">
        Test MCP server connectivity and optional search tool execution using servers from User Settings → MCP.
      </p>
      <div className="web-search-test-form">
        <div className="form-group">
          <label htmlFor="mcpServer">MCP server</label>
          <select id="mcpServer" className="form-control" value={serverId} onChange={(e) => setServerId(e.target.value)} disabled={running || !servers.length}>
            {servers.map((s) => (
              <option key={s.id} value={s.id}>{s.name} ({s.transport})</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="mcpQuery">Optional search query</label>
          <input id="mcpQuery" className="form-control" value={query} onChange={(e) => setQuery(e.target.value)} disabled={running} placeholder="Leave blank to test connection only" />
        </div>
        <button type="button" className="btn btn-primary" onClick={handleRun} disabled={running || !serverId}>
          {running ? <><i className="fas fa-spinner fa-spin" /> Running…</> : <><i className="fas fa-plug" /> Run MCP test</>}
        </button>
      </div>
      {result && (
        <div className="web-search-test-results">
          <h4>Result</h4>
          <pre className="ws-result-error-details">{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}

export default AiMcpTestPanel;
